import React from "react"
import Container from "./Container"
import dami_image from "../images/home/team/dami_image.png"
import obi_image from "../images/home/team/obi_image.png"
import mir_image from "../images/home/team/mir_image.png"
import arezoo_image from "../images/home/team/arezoo_image.jpeg"

function Team() {
  const teamMembers = [
    {
      image: obi_image,
      name: "OBI IKEGULU",
      description: "DIRECTOR",
    },
    {
      image: arezoo_image,
      name: "AREZOO SHAHSAVARI",
      description: "Project Manager",
    },
    {
      image: mir_image,
      name: "MIR AIMAN ALI",
      description: "Project Surveyor",
    },
    {
      image: dami_image,
      name: "DAMILOLA S.",
      description: "Human Resources",
    },
  ]

  return (
    <Container>
      <div className="flex flex-col items-center w-full mb-[268px]">
        <p className="uppercase text-[24px] mb-[30px] lg:mb-[81px] w-full text-center lg:text-[40px] lg:w-[800px] font-[700] leading-[34px] lg:leading-[68px]">
          A GLIMPSE OF OUR EXPERT TEAM
        </p>
        <div className="w-full  flex gap-8 justify-center flex-wrap">
          {teamMembers.map(member => (
            <div className="flex flex-col items-center">
              <div
                style={{ backgroundImage: `url('${member.image}')` }}
                className="w-[282px] h-[282px] bg-cover bg-center  rounded-full mb-4"
              >
                {/* <img className="w-full" src={member.image} alt="" /> */}
              </div>
              <p className="uppercase font-[600] text-[20px] text-[#222222] mb-1">
                {member.name}
              </p>
              <p className=" font-[400] text-[14px] text-[#333333]">
                {member.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </Container>
  )
}

export default Team
